import React, {useCallback, useContext, useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import EurailPassPage from '../eurailPassPage/EurailPassPage';
import NationalRailPage from '../nationalRailPage/NationalRailPage';
import AmtrakFaq from '../amtrakFaq/amtrakFaq';
import AirportStations from '../airportStations/airportStationsPage';
import ViaFaq from '../viaFaq/viaFaq';
import SearchBox from '../homePage/searchBox/SearchBox';
import CareersSection from '../homePage/careersSection/CareersSection';
import { staticContent } from '../shared/static/StaticContent';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import DiscoverSectionContext from '../context/discoverSectionPages';
import CustomCard from '../shared/customCard/CustomCard';
import axios from 'axios';
import { Urls } from '../context/Urls';
import { setSelectedArrivalStation, setSelectedDestinationStation } from '../redux/actions/pointToPointActions';
import './trainTimeTable.scss';
import { setLoading } from '../redux/actions/commonActions';
import {Helmet} from "react-helmet-async";
import heroImage from './../assets/images/heroImage3.webp';

import imagesPool from '../utils/heroImages'

const TrainTimeTable = () => {
    const [mainText, setMainText] = useState(staticContent.AU.heroTitle);
    const [isColorChange, setIsColorChange] = useState(false);
    const [secondaryText, setSecondaryText] = useState(staticContent.AU.heroSubTitle);
    const browseFrom = useAppSelector((state) => state.common.isLoading);
    const { type } = useContext(DiscoverSectionContext)
    const [popularJourneys, setPopularJourneys] = useState<any>([]);
    const dataList = useAppSelector((state) => state.trainStations.trainStations);
    const dispatch = useAppDispatch();
    const user = useAppSelector((state) => state.loggedInUser.profile);
    const [agencyHome, setAgencyHome] = useState<boolean>(false);

    const changeContent = useCallback((contentsTo) => {
        switch (contentsTo.toString().toUpperCase()) {
            case '/AU':
                setMainText(staticContent.AU.heroTitle);
                setSecondaryText(staticContent.AU.heroSubTitle);
                setIsColorChange(false)
                break;
            case '/UK':
                setMainText(staticContent.UK.heroTitle);
                setSecondaryText(staticContent.UK.heroSubTitle);
                setIsColorChange(false)
                break;
            case '/US':
                setMainText(staticContent.US.heroTitle);
                setSecondaryText(staticContent.US.heroSubTitle);
                setIsColorChange(true)
                break;
            case '/CA':
                setMainText(staticContent.CA.heroTitle);
                setSecondaryText(staticContent.CA.heroSubTitle);
                setIsColorChange(true)
                break;
            default:
                setMainText(staticContent.AU.heroTitle);
                setSecondaryText(staticContent.AU.heroSubTitle);
                setIsColorChange(false)
                break;
        }
    }, [])

    useEffect(() => {
        changeContent(browseFrom)
    }, [browseFrom, changeContent]);

    const handleSlide = (eventKey: number) => {
        if (eventKey < imagesPool.length && imagesPool[eventKey].isUs) {
          changeContent('/US')
        }
        else if (eventKey < imagesPool.length && imagesPool[eventKey].isCa) {
          changeContent('/CA')
        } else {
          changeContent(browseFrom)
        }
      }

      useEffect(() => {
        if (user?.userRole === "B2BAdmin" || user?.userRole === "B2BAgent") {
            setAgencyHome(true)
        } else {
            setAgencyHome(false)
        }
      }, [user?.userRole])

    const ukDataSet = [
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            showTo: 'Edinburgh (Waverley)',
            to: 'Edinburgh (Waverley)',

        },
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            showTo: 'Oxford',
            to: 'Oxford',

        },
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            to: 'Manchester (All Stations)',
            showTo: 'Manchester',

        },
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            to: 'Liverpool (All Stations)',
            showTo: 'Liverpool',

        },
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            to: 'Brighton',
            showTo: 'Brighton',

        },
        {

            showFrom: 'London',
            from: 'London (All Stations)',
            to: 'Cambridge',
            showTo: 'Cambridge',

        },
        {

            showFrom: 'Boston',
            from: 'Boston (Back Bay Station), MA',
            showTo: 'New York',
            to: 'New York, NY'
        },
        {

            from: 'New York, NY',
            showFrom: 'New York',
            showTo: 'Boston',
            to: 'Boston (Back Bay Station), MA',

        },
        {

            from: 'New York, NY',
            showFrom: 'New York',
            showTo: 'Washington',
            to: 'Washington, DC'

        },
        {

            from: 'Seattle (King Street Station), WA',
            showFrom: 'Seattle',
            to: 'Vancouver, WA',
            showTo: 'Vancouver',

        },
        {

            showFrom: 'Los Angeles',
            from: 'Los Angeles, CA',
            showTo: 'San Diego',
            to: 'San Diego (Downtown), CA',

        },
        {

            from: 'Chicago (Union Station), IL',
            showFrom: 'Chicago',
            showTo: 'Seattle',
            to: 'Seattle (King Street Station), WA',

        },
    ];

    useEffect(() => {
        dispatch(setLoading(true))
        axios
            .get(Urls.APP_BASE_URL + "point-to-point/get-all-popular-journey")
            .then((res: any) => {
                const resData = res?.data?.body;
                const ukData = ukDataSet.map((item: any) => ({
                    ...item,
                    price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from)).info?.price,
                    journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from)).info?.duration.shortedDescription,
                    provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from)).provider
                }));
                dispatch(setLoading(false))
                setPopularJourneys(ukData);

            }).catch((e) => {
                console.log(e)
            })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    let pageToLoad = < TrainTimeTable />
    switch (type) {
        case 'EurailPassPage':
            pageToLoad = <EurailPassPage />
            break;
        case 'NationalRailPage':
            pageToLoad = <NationalRailPage />
            break;
        case 'AmtrakFaq':
            pageToLoad = <AmtrakFaq />
            break;
        case 'AirportStations':
            pageToLoad = <AirportStations />
            break;
        case 'ViaFaq':
            pageToLoad = <ViaFaq />
            break;
        case undefined:
            pageToLoad = < ViaFaq />
            break;
        default:
            pageToLoad = < ViaFaq />
    }

    const handleClickOnItem = (val: any) => {
        const toStation = dataList.find((item: any) => item.text === val.to.toString())
        const fromStation = dataList.find((item: any) => item.text === val.from.toString())

        dispatch(setSelectedDestinationStation(fromStation));
        dispatch(setSelectedArrivalStation(toStation));
    }
    const questions = [

        {
            table:
                <div className="table-container-trainTimeTable">
                    <CustomCard>
                        {popularJourneys && <table className="table">

                            <thead >
                                <tr>
                                    <th>Route</th>
                                    <th>Fastest journey time</th>
                                    <th>Cheapest fare</th>
                                </tr>
                            </thead>
                            <tbody>
                                {popularJourneys && popularJourneys.map((item: any, index: any) =>

                                    <tr key={index} >
                                        <td className="row-click-tr" onClick={() => handleClickOnItem(item)}>{item.showFrom} to {item.showTo}</td>
                                        <td>{item.journeyTime}</td>
                                        <td>AUD {item.price}</td>
                                    </tr>
                                )}

                            </tbody>

                        </table>}
                    </CustomCard>

                </div>
        },
    ]

    return (
        <div className="container-fluid">
            <Helmet>
                <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
                <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
                <link rel="canonical" href={`${process.env.REACT_APP_PUBLIC_URI}/train-time`}/>
            </Helmet>
            {!agencyHome ? <div className="row">
                <div className="col-sm-12 p-0">
                    <div className="hero-image-container">
                        <div className="image-box">
                            <div className="background-shade"></div>
                            <Carousel indicators={false} onSlide={handleSlide} className="carousal">
                                {
                                    imagesPool.map((item, index) => (
                                        <Carousel.Item key={index}>
                                            <img className="img-fluid hero-image" src={item.src} loading="lazy" alt="heroImage" />
                                        </Carousel.Item>
                                    ))
                                }
                            </Carousel>
                            <div className={`center-text ${isColorChange ? 'change-color' : null}`}>
                                <h1>{mainText}</h1>
                                <h2>{secondaryText}</h2>
                            </div>
                        </div>
                        <div className="search-box max-width">
                            <SearchBox />
                        </div>
                        <CareersSection />
                    </div>
                    {type !== undefined && pageToLoad}

                </div>
            </div> : <div className="hero-image-container">
                <div className="background-shade d-none d-md-flex opacity-change"></div>
                <img className="img-fluid hero-image d-none d-md-flex" src={heroImage} alt="heroImage" />
                <div className="about-us-page--title">
                    <h1>Popular UK and US Train Timetable</h1>
                </div>
            </div>}
            
            {type === undefined && <div className="container-fluid max-width mb-5">
                <div className="common-page">
                    <div className="common-page--content-area max-width about-us-page">

                        <h1 className="mt-5 mb-3 text-left">Popular UK and US Train Timetable</h1>
                        {
                            questions.map(({ table }) => (
                                <div className="qa-box">

                                    <div className="p-2 p-md-3 text-align left">{table}</div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>}

        </div>


    );
}


export default TrainTimeTable;


